export const currencyFormatter = (currencyValue, minFractionLimit = 0) =>
  '$'.concat(
    Number(currencyValue).toLocaleString('en', {
      minimumFractionDigits: minFractionLimit,
      maximumFractionDigits: 2,
    }),
  );
